/* eslint-disable no-param-reassign */

const initialState = () => ({
  hideScrollToTop: false,
  showHigher: false,
});

export { initialState as state };

export const mutations = {
  updateHideScrollToTop(state, data) {
    state.hideScrollToTop = data;
  },
  updateShowHigher(state, data) {
    state.showHigher = data;
  },
};

export const actions = {
  updateVisibility({ commit }, { hideScrollToTop }) {
    commit('updateHideScrollToTop', hideScrollToTop);
  },
  updateHeight({ commit }, { showHigher }) {
    commit('updateShowHigher', showHigher);
  },
};
